import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const LessonLocaleFormCompletionSync = ({
  activeLocale,
  localeContentLoading,
  onFormTasksChange,
}: {
  activeLocale: string;
  localeContentLoading: boolean;
  onFormTasksChange: (locale: string, tasks: unknown) => void;
}): null => {
  const { values } = useFormikContext<{ tasks?: unknown }>();

  useEffect(() => {
    if (localeContentLoading || !Array.isArray(values.tasks)) {
      return;
    }

    onFormTasksChange(activeLocale, values.tasks);
  }, [activeLocale, localeContentLoading, onFormTasksChange, values.tasks]);

  return null;
};

export default LessonLocaleFormCompletionSync;
